import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import JoinWithUs from "../../Home/JoinWithUs";

import HeroDeFiDev from "./HeroDeFiDev";
import NewRealmDeFi from "./NewRealmDeFi";
import IndustryGrowth from "./IndustryGrowth";
import DeFiDevServiceXeer from "./DeFiDevServiceXeer";
import OurDeFiServices from "./OurDeFiServices";
import ExploreDeFiPlatforms from "./ExploreDeFiPlatforms";
import DevelopmentApproach from "./DevelopmentApproach";
import WhyChooseXeerDev from "./WhyChooseXeerDev";

function DeFiDevelopment() {
  return (
    <div id="smooth-content">
      <Header />
      <HeroDeFiDev />
      <NewRealmDeFi />
      <IndustryGrowth />
      <DeFiDevServiceXeer />
      <OurDeFiServices />
      <ExploreDeFiPlatforms />
      <DevelopmentApproach />
      <WhyChooseXeerDev />
      <div style={{ marginTop: "100px" }}>
        <JoinWithUs />
      </div>
      <Footer />
    </div>
  );
}

export default DeFiDevelopment;
